import {XauditModel} from '../xaudit.model';

export class WorkstationDevicesConfigurationModel extends XauditModel{
  WorkStationDeviceID: string;
  WorkStationId: string;
  Name: string;
  enumDeviceCategoryID: string;
  DeviceID: string;
  isConnected: boolean = true;
  isActive: boolean = true;
  isDefault: boolean = true;
  isStartFolderMonitor: boolean = false;
  ParametersJSON: string;

}

export class DeviceParameters  {
  twainDriver: string;
}
export class FolderMonitorParameters  {
  MonitorName: string;
}
export class PrinterParameters  {
  printerName: string;
}

export class CalibrationParameters  {
  rulerLength: number;
  sourceLength: number;
}
